import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ThreadMessage, ConversationContact, Message, MessageAttachment, Attachment } from 'app/clmtlk/shared/model/conversationContacts';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { WindowRefService } from 'app/common/service/window-ref.service';
import {saveAs as importedSaveAs} from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { BlockUIService } from 'ng-block-ui';


// declare let userAgent: any;
// declare let safari: any;

@Component({
  selector: 'clmtlk-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MessageComponent implements OnInit {

  @Input() threadMessage: ThreadMessage;
  message: Message;
  messageAttachments: MessageAttachment[];
  private window: Window;

  constructor(private clmtlkSessionService: ClmtlkSessionService,
     private clmtlkService: ClmtlkService,
     private toastrService: ToastrService ,
     private blockUIService: BlockUIService,
     private windowService: WindowRefService) {
      this.window = windowService.nativeWindow;
  }
  ngOnInit() {

    this.message = this.threadMessage.messages.message[0];

    let content: string = this.message.MSG_CNTNT_XML;
    content = content.replace('<![CDATA[', '').replace(']]>', '');
    this.message.MSG_CNTNT_XML = content;
    if ( this.message.messageAttachments && this.message.messageAttachments.messageAttachment) {
      this.messageAttachments = this.message.messageAttachments.messageAttachment;
    }

  }

  displayContactAddress(conversationContacts: ConversationContact[], type: string): string {

    const loggedinUser: ConversationContact = this.clmtlkSessionService.loggedInContact;
    const isStreamUser: boolean = loggedinUser && loggedinUser.CTC_SRC_CD === 'st';

    let contactAddress = '';
    let startIndex = 0;
    conversationContacts.forEach((conversationContact: ConversationContact) => {
      if (conversationContact.CTC_ADDR_TYP_CD === type) {

        let contactDisplay: string = conversationContact.contacts.contact[0].CTC_NM +
                                      (conversationContact.CTC_IMPRS_NM ?
                                      `( ${conversationContact.CTC_IMPRS_NM} )` : '');
        if (isStreamUser) {
          contactDisplay = `${contactDisplay}( ${conversationContact.contacts.contact[0].CTC_VAL_TXT} )`;
        }

        if ( conversationContact.CTC_STS_CD.toUpperCase() !== 'V' ) {
          contactDisplay = `<i class="text-danger">${contactDisplay}</i>`;
        }

        contactAddress = (startIndex === 0) ? contactDisplay : contactAddress + ', ' + contactDisplay;
        startIndex++;
      }
    });
    return contactAddress;
  }

  showTransformedMessage(message: string) {
    return message.replace('<![CDATA[', '').replace(']]>', '');
  }

  downloadFile(attachment: Attachment) {
    this.blockUIService.start('main', 'Downloading file... please wait');
    this.clmtlkService.dowloadFile(attachment)
    .subscribe( blob => {
          // const blob1 = new Blob([blob], {type: 'image/jpg'});
          const userAgent = navigator.userAgent || navigator.vendor || this.window['opera'];
          this.window.URL = this.window.URL || this.window['webkitURL'];
          console.log(userAgent);
          const window = this.window;
          // For IE
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, attachment.ATTCH_FILE_NM);

          // For Mobile (ipad, iphone, ipod) Safari
          } else if (/iP(ad|hone|od).+MAC.OS.X/i.test(userAgent)) {
            console.log(' inside ios ');

            // Chrome IOS
            if (/CriOS/i.test(userAgent)) {
              const reader = new FileReader();
              reader.onloadend = function () { window.open(reader.result); };
              reader.readAsDataURL(blob);

            // Safari and others  /Version\/[\d\.]+.*Safari/i
            }else {
              const url = window.URL.createObjectURL(blob);
              window.location.href = url;
            }
          // All Other
          }else {
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
          }

          // importedSaveAs(blob, attachment.ATTCH_FILE_NM);
    }, error => {
     this.blockUIService.stop('main');
     this.toastrService.error(`File download Failed - ${error}`, 'Unsuccess',
              { closeButton: true, positionClass: 'toast-top-full-width', tapToDismiss: false , timeOut: 0} );
    },
     () => {
      this.blockUIService.stop('main');
     }
  );
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/shared/component/message-list/message/message.component.ts